import clsx from 'clsx';
import {keys, map, size} from 'lodash';
import {useController} from 'react-hook-form';

import './GeneControl.scss';

export default function GeneControl({
  control, name, alleles = [], phenotypes = [],
  displaySingleAllele = false,
  allowSingleAllele = false,
  className,
}) {
  const {field: fieldA1} = useController({
    control,
    name: `${name}.0`,
    rules: {
      validate: (value) => {
        if (allowSingleAllele) return true;
        const otherValue = control._getWatch(`${name}.1`);
        if ((!value && !otherValue) || (value && otherValue)) return true;
        return 'Both alleles must be selected';
      },
    }});
  const {field: fieldA2, fieldState: {error: errA1}} = useController({
    control,
    name: `${name}.1`,
    rules: {
      validate: (value) => {
        if (allowSingleAllele) return true;
        const otherValue = control._getWatch(`${name}.0`);
        if ((!value && !otherValue) || (value && otherValue)) return true;
        return 'Both alleles must be selected';
      },
    }});
  const {field: fieldP} = useController({control, name: `${name}.2`});

  const hasGeno = size(fieldA1.value) > 0 || size(fieldA2.value) > 0;
  const hasPheno = size(fieldP.value) > 0;
  
  return (
    <div className="gene-control_container">
      <div className="gene-control_gene">
        {name}
      </div>
      <div className="gene-control_field">
        <select {...fieldA1} disabled={hasPheno}>
          <option value="">--</option>
          {map(alleles, (allele) => <option key={allele}>{allele}</option>)}
        </select>
        {errA1?.message && <div className="text-danger">{errA1.message}</div>}
      </div>
      <div className="gene-control_field">
        <select {...fieldA2} disabled={hasPheno} className={clsx({'d-none': displaySingleAllele})}>
          <option value="">--</option>
          {map(alleles, (allele) => <option key={allele}>{allele}</option>)}
        </select>
      </div>
      <div className="gene-control_or">
        {size(phenotypes) > 0 ? 'or' : ''}
      </div>
      <div className="gene-control_field">
        <select {...fieldP} disabled={hasGeno} className={clsx({'d-none': size(phenotypes) === 0})}>
          <option value="">--</option>
          {map(keys(phenotypes), (pheno) => <option key={pheno} value={phenotypes[pheno]}>{pheno}</option>)}
        </select>
      </div>
    </div>
  );
}
